'use strict';

angular.module('licensure.services')
    .factory('IPExtraFees', ['$http', '$q', function ($http, $q) {

        return {
            getByID: function (id) {
                var d = $q.defer();

                $http
                    .get(apiLocation + '/api/Core/IPExtraFees/' + id, {
                        params: {

                        }
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },

            createFee: function (fee) {
                var d = $q.defer();

                $http.post(apiLocation + '/api/Core/IPExtraFees/', fee)
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },

            updateFee: function (fee) {
                var d = $q.defer();

                $http.put(apiLocation + '/api/Core/IPExtraFees/' + fee.id, fee)
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },

            deleteFee: function (id) {
                var d = $q.defer();

                $http
                    .delete(apiLocation + "/api/Core/IPExtraFees/" + id, {
                        params: {}
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },
        };
    }])
    ;